<template>
 <div class="wrap talk">
		<header>
			<h1><a href="#" class="logo"></a></h1>
		</header>
		<div class="container">
			<main class="content">
				<article class="certification">
					<section class="txt">
						<h2>PASS 본인인증</h2>
						<p><span>인증이</span>완료되었습니다!</p>
					</section>
					<section class="">
						<div class="box row row_c row_jsc">
							<h1>ATM 인증번호</h1>
							<p>ATM에 아래의 두자리 번호를<br>입력한 후 서비스를 진행해 주세요.</p>
							<div class="num">
								<span>{{secKey1}}</span>
								<span>{{secKey2}}</span>
							</div>
						</div>
					</section>
				</article>
				<article class="keypad-wrap">
					<section class="keypad">
						<h1><a href="#" class="logo"></a></h1>
						<div class="keypad-box">
							<p><span>알림톡으로 발송된</span>인증번호를 입력해 주세요.</p>
							<div class="num">
								<span>{{secKey1}}</span>
								<span>{{secKey2}}</span>
							</div>
							<ul class="keypad-num row row_jsb row_wrap">
								<li>1</li>
								<li>2</li>
								<li>3</li>
								<li>4</li>
								<li>5</li>
								<li>6</li>
								<li>7</li>
								<li>8</li>
								<li>9</li>
								<li><i class="xi-arrow-left"></i></li>
								<li>0</li>
								<li>초기화</li>
							</ul>
							<div class="keypad-btn row row_jsb">
								<div><a href="#" class="home"><i class="xi-home"></i></a></div>
								<div class="arrow">
									<a href="#"><i class="xi-angle-left-min"></i></a>
									<a href="#"><i class="xi-angle-right-min"></i></a>
								</div>
							</div>
						</div>
					</section>
				</article>
			</main>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'


export default {
  name: 'CrtfPassSuc',
  components: { 

   },
  data: () => ({
    AppConfig: AppConfig,
    
    secKey1:'0',
    secKey2:'6',    

  }),
  computed: {

  },
  mounted() {

    this.secKey1 = this.$route.query.secKey1
    this.secKey2 = this.$route.query.secKey2

  },
  methods: {

    async certPassSuc () {

      const params = {
        atmId       : 'bos_test',
        prncCrtfNum : window.btoa('XADLAo0zndl4moDY1YzGmA=='),
        encData     : this.$route.query.EncodeData,
        param_r2    : this.$route.query.param_r2,
      }      

      console.log('params ==> {}', params)

      const rtn = await Vue.httpClient
        .get('/api/purchase/crtf/public/crtfPassSuc', {params} )
        .then(res => {
          if (res.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
            if (res.data.result) {
              console.log(res.data.result)
            } 
          } else {
            Vue.Alert.alert("통신 오류 입니다.")
          }
        })

    },   

  }
}
</script>



// WEBPACK FOOTER //
// src/views/crtfpass/CrtfPassSuc.vue